<template>
    <div>
        <emails-panel/>
        <footers-panel/>
    </div>
</template>

<script>
    import EmailsPanel from "../components/Emails/EmailsPanel";
    import FootersPanel from "../components/Footers/FootersPanel";

    export default {
        name: "EmailBoxes",
        components: { FootersPanel, EmailsPanel },
    }
</script>

<style/>